import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import './assets/scss/main.css';
import './assets/scss/kairos.css';
import { applyBrandTokens } from './utils/brand';
import './registerServiceWorker';
import VueClipboard from 'vue-clipboard2';
import AOS from 'aos';
import 'aos/dist/aos.css';
import VueApexCharts from 'vue-apexcharts';
Vue.use(VueApexCharts);

Vue.component('apexcharts', VueApexCharts);

AOS.init();
VueClipboard.config.autoSetContainer = true; // add this line
Vue.use(VueClipboard);
Vue.config.productionTip = false;

/* apply whitelabel brand colours before first paint */
applyBrandTokens();

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
}).$mount('#app');
